import { useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function appendScript(id, src, innerHTML) {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  if (src) {
    script.async = true;
    script.src = src;
  }
  if (innerHTML) script.innerHTML = innerHTML;
  document.head.appendChild(script);
}

export default function SEOTracking() {
  const { settings } = useSettings();

  useEffect(() => {
    const verification = (settings.google_search_console_verification || "").trim();
    const gaId = (settings.google_analytics_id || "").trim();

    if (verification) {
      upsertMeta("google-site-verification", verification);
    }

    if (/^G-[A-Z0-9]+$/i.test(gaId)) {
      appendScript("sf-ga-loader", `https://www.googletagmanager.com/gtag/js?id=${gaId}`);
      appendScript(
        "sf-ga-config",
        null,
        `window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}\ngtag('js', new Date());\ngtag('config', '${gaId}');`
      );
    }
  }, [settings.google_analytics_id, settings.google_search_console_verification]);

  return null;
}
